import axios from 'axios'
import { url, getCustomHeaders } from 'components/DataProvider/functions'
import { assign } from 'lodash'
import { isNil, toString } from 'lodash/fp'
import log from 'loglevel'

log.setLevel(log.levels.DEBUG)

const getData = async (
  url: string,
  headers: Record<string, string>
): Promise<any> => {
  const { status, data } = await axios.get(url, {
    headers
  })
  return status === 200 ? data : undefined
}

export const doAnnouncesDownload = async (
  partner: string,
  common: boolean = false
): Promise<{ data: any; files?: string[] }> => {
  if (isNil(url)) return { data: undefined }
  const customHeaders = getCustomHeaders({}, partner)
  if (isNil(customHeaders)) return { data: undefined }
  const headers = {}
  customHeaders.forEach((value: string, key: string, _parent: Headers) => {
    assign(headers, { [key]: value })
  })
  const data = await getData(
    `${url}/announce/sapp/${toString(common)}`,
    headers
  )
  if (isNil(data)) return { data: undefined }
  const files = await getData(
    `${url}/announce/file/sapp/${toString(common)}`,
    headers
  )
  return { data, files: isNil(files) ? [] : files }
}
export const doAnnouncesUpload = async (
  partner: string,
  data: FormData,
  common: boolean = false
): Promise<number> => {
  if (isNil(url)) return 500
  const customHeaders = getCustomHeaders({}, partner)
  if (isNil(customHeaders)) return 500
  customHeaders.set('Content-Type', 'multipart/form-data;charset=UTF-8')
  const headers = {}
  customHeaders.forEach((value: string, key: string, _parent: Headers) => {
    assign(headers, { [key]: value })
  })
  const { status } = await axios.post(
    `${url}/announce/sapp/${toString(common)}`,
    data,
    {
      headers
    }
  )
  return status
}
